var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"timetable"},[_c('h2',{staticClass:"timetable__title"},[_vm._v("Страница не найдена")])])
}]

export { render, staticRenderFns }